import { Store } from "../../pages/Hospitality/Content/section/interfaces"


type CardStoreHotelProps = {
    store: Store
    isSelected: boolean
}

const CardStoreHotel = ({ store, isSelected }: CardStoreHotelProps) => {
    return (
        <>
            <div className={`card-body p-3  border border-3 ${isSelected ? 'border-primary' : ''} rounded`}>
                <div className='d-flex'>
                    <div className='me-3'>
                        {store.img ? (
                            <img
                                src={store.img}
                                alt={store.name}
                                style={{ width: 72, height: 72, objectFit: 'cover' }}
                                className='rounded'
                            />
                        ) : (
                            <div
                                className='bg-light rounded d-flex align-items-center justify-content-center'
                                style={{ width: 72, height: 72 }}
                            >
                                <i className='fas fa-store text-muted fs-2'></i>
                            </div>
                        )}
                    </div>

                    <div className='flex-grow-1'>
                        <h5 className='fw-bold mb-1'>{store.name}</h5>
                        <div className='text-muted fs-7 mb-2'  dangerouslySetInnerHTML={{ __html: store.description }} />
                        <div className='d-flex flex-wrap gap-2 align-items-center'>
                            <span className='badge badge-light'>Ordem: {store.order}</span>
                            <span className={`badge ${store.status ? 'badge-success' : 'badge-danger'}`}>
                                {store.status ? 'Ativo' : 'Inativo'}
                            </span>
                            {store.type && <span className='badge badge-light'>{store.type}</span>}
                            {store.cnpj && <span className='badge badge-light'>CNPJ: {store.cnpj}</span>}
                            {store.paymentIntegrated && <span className='badge badge-info'>Pagamento: {store.paymentIntegrated}</span>}
                        </div>
                    </div>
                </div>

            </div>
        </>
    )
}

export default CardStoreHotel